import axios from 'axios';

export const getCancelledBacsReport = async (options = {}) => {
  const params = {};
  if (options.programName) params.programName = options.programName;
  if (options.source) params.source = options.source;
  if (options.includeAppsheet === false) params.includeAppsheet = 'false';
  if (Number.isFinite(options.limit)) params.limit = options.limit;
  if (Number.isFinite(options.offset)) params.offset = options.offset;

  const { data } = await axios.get('/api/cancellations', {
    params: Object.keys(params).length ? params : undefined,
  });
  return data;
};
